import { Route, Switch } from 'react-router-dom';
import Products from './Products.component';
import ProductDetails from './details/ProductDetails.component';
import ProductProvider from '../../context/SearchProduct';
import { useStore } from '../../context/Store';

const Routes = () => {
  const { store } = useStore();

  return (
    <ProductProvider>
      <Switch>
        <Route exact path="/produtos" component={Products} />
        {store && <Route exact path="/produtos/:id" component={ProductDetails} />}
        <Route component={() => <>Página não encontrada</>} />
      </Switch>
    </ProductProvider>
  );

}

export default Routes;
